/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { UiMenuShapeSquare4TiltIcon16Light } from './UiMenuShapeSquare4TiltIcon16Light';
import { UiMenuShapeSquare4TiltIcon16Regular } from './UiMenuShapeSquare4TiltIcon16Regular';
import { UiMenuShapeSquare4TiltIcon16Solid } from './UiMenuShapeSquare4TiltIcon16Solid';
import { UiMenuShapeSquare4TiltIcon20Light } from './UiMenuShapeSquare4TiltIcon20Light';
import { UiMenuShapeSquare4TiltIcon20Regular } from './UiMenuShapeSquare4TiltIcon20Regular';
import { UiMenuShapeSquare4TiltIcon20Solid } from './UiMenuShapeSquare4TiltIcon20Solid';
import { UiMenuShapeSquare4TiltIcon24Regular } from './UiMenuShapeSquare4TiltIcon24Regular';
import { UiMenuShapeSquare4TiltIcon24Solid } from './UiMenuShapeSquare4TiltIcon24Solid';
import { UiMenuShapeSquare4TiltIcon32Regular } from './UiMenuShapeSquare4TiltIcon32Regular';
import { UiMenuShapeSquare4TiltIcon64Regular } from './UiMenuShapeSquare4TiltIcon64Regular';
var sizes = {
    16: {
        light: UiMenuShapeSquare4TiltIcon16Light,
        regular: UiMenuShapeSquare4TiltIcon16Regular,
        solid: UiMenuShapeSquare4TiltIcon16Solid,
    },
    20: {
        light: UiMenuShapeSquare4TiltIcon20Light,
        regular: UiMenuShapeSquare4TiltIcon20Regular,
        solid: UiMenuShapeSquare4TiltIcon20Solid,
    },
    24: {
        regular: UiMenuShapeSquare4TiltIcon24Regular,
        solid: UiMenuShapeSquare4TiltIcon24Solid,
    },
    32: {
        regular: UiMenuShapeSquare4TiltIcon32Regular,
    },
    64: {
        regular: UiMenuShapeSquare4TiltIcon64Regular,
    },
};
export var UiMenuShapeSquare4TiltIcon = forwardRef('UiMenuShapeSquare4TiltIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
